import { addDays } from 'date-fns'

import { getIsoDate } from '@subaio/utils'

export enum DeprecatedType {
	Moved = 'MOVED',
	Deleted = 'DELETED',
}

enum DeprecatedProperties {
	Type = 'TYPE',
	MovedTo = 'MOVED_TO',
	Description = 'DESCRIPTION',
	MarkedAt = 'MARKED_AT',
	RemovedWhenInDays = 'REMOVED_WHEN_IN_DAYS',
}

type Properties = {
	type: DeprecatedType
	movedTo: string | null
	description: string | null
	markedAt: Date | null
	removedWhenInDays: number
}

export const getDeprecatedProperties = (description: string, fieldName: string) => {
	const deprecatedText = /DEPRECATED\{\{(?:.*\n*)*\}\}/.exec(description)

	const properties: Properties = {
		type: DeprecatedType.Deleted,
		movedTo: null,
		description: null,
		markedAt: null,
		removedWhenInDays: 180,
	}
	if (deprecatedText?.[0]) {
		const parts = deprecatedText[0].matchAll(/(\w+)\{(.+)\}\n/g)

		for (const match of parts) {
			switch (match[1]) {
				case DeprecatedProperties.MovedTo: {
					properties.movedTo = match[2]
					properties.type = DeprecatedType.Moved
					break
				}
				case DeprecatedProperties.Description: {
					properties.description = match[2]
					break
				}
				case DeprecatedProperties.MarkedAt: {
					properties.markedAt = new Date(match[2])
					break
				}
				case DeprecatedProperties.RemovedWhenInDays: {
					properties.removedWhenInDays = Number.parseInt(match[2], 10)
					break
				}
			}
		}
	}

	if (properties.markedAt === null) {
		throw new Error(`
			The field ${fieldName} has been marked as deprecated without specifying the time it was marked as deprecated. Please supply a string in the description with these properties at minimum:
			DEPRECATED{{
				MARKED_AT{${getIsoDate(new Date())}}
			}}
		`)
	}

	return {
		...properties,
		markedAt: properties.markedAt,
		removedWhen: addDays(properties.markedAt, properties.removedWhenInDays),
	}
}
